import React from "react";
import classes from "./ShopIcon.module.scss";

/**
 * 店舗アイコンのプロパティ
 */
type ShopIconProps = {
  /** 店舗画像 */
  image: string;
  /** 店舗名 */
  name: string;
  /** クリック時の処理 */
  onClick: () => void;
};

/**
 * 店舗アイコン
 * @param props 店舗アイコンのプロパティ
 */
const ShopIcon: React.FC<ShopIconProps> = (props) => {
  return (
    <div onClick={props.onClick}>
      <div className={classes.shopIcon}>
        <div className={classes.iconContainer}>
          <img
            className={`img-fluid ${classes.icon}`}
            src={props.image}
            alt={props.name}
          />
        </div>
      </div>
      <div className={classes.shopName}>{props.name}</div>
    </div>
  );
};

export default ShopIcon;
